import React from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";

let buttonStyle = {
    'width':'100%',
    'color': '#ffffff',
    'font-weight': '600',
    'background': 'rgba(24, 128, 56, 1)',
    'padding': '10px 30px',
    'font-size': '16px',
    'border-radius': '5px',
    'letter-spacing': '0.2px',
    'text-decoration': 'none',
    'display': 'block',
    'text-align': 'center',
    'text-transform': 'uppercase',
};

const BtnCustom = ({ path, name, onClick}) => {
  
  return (
    <>
      <div className="fix-btn-bg">
        <Link to={`/${path}`} style={buttonStyle} className="btn-main" onClick={onClick} >
          {name}
        </Link>
      </div>
    </>
  );
};

export default BtnCustom;
